export default __webpack_public_path__ + "static/media/icon_report_normal.50460e11.svg";